import React, {useEffect} from 'react';
import Modal from 'shared/components/modal';
import CollegeApplicationStatusCards from 'shared/college-application-status/components/college-application-status-cards';
import {useHistory, useLocation} from 'react-router-dom';

interface FollowedCollege {
  admissionsWebsite: string;
  applicationWebsite: string;
  city: string;
  financialAidWebsite: string;
  logo: string;
  name: string;
  state: string;
  website: string;
  _id: string;
}

interface CollegeApplicationStatuses {
  collegeId: string;
  createdAt: string;
  status: string;
  updatedAt: string;
}

interface CollegeApplicationStatusModalProps {
  followedColleges: FollowedCollege[];
  collegeApplicationStatuses: CollegeApplicationStatuses[];
  getFollowedColleges: () => void;
  getCollegeAppStatuses: () => void;
  setCollegeAppStatus: () => void;
}

const CollegeApplicationStatusModal = ({
  followedColleges,
  collegeApplicationStatuses,
  getFollowedColleges,
  getCollegeAppStatuses,
  setCollegeAppStatus,
}: CollegeApplicationStatusModalProps) => {
  const location = useLocation();
  const history = useHistory();

  const handleCloseModal = () => {
    history.push(location.pathname.replace('/application-status', ''));
  };

  useEffect(() => {
    getFollowedColleges();
    getCollegeAppStatuses();
  }, [getFollowedColleges, getCollegeAppStatuses]);

  return (
    <Modal show onClose={handleCloseModal}>
      <Modal.TextHeader onClose={handleCloseModal}>College Application Status</Modal.TextHeader>
      <Modal.Body>
        <p data-testid="college-application-status">
          Share your application status so colleges can better help you.
        </p>
        <CollegeApplicationStatusCards
          colleges={followedColleges}
          collegeApplicationStatuses={collegeApplicationStatuses}
          setCollegeAppStatus={setCollegeAppStatus}
        />
      </Modal.Body>
      <Modal.Footer
        primaryButton={{
          text: 'Close',
          onClick: () => handleCloseModal(),
        }}
      />
    </Modal>
  );
};

export default CollegeApplicationStatusModal;
